<template>
  <v-container fluid>
    <v-data-table
      :headers="headers"
      class="elevation-1"
      :items="tipos"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <datatable-filters
            :filters="filters"
            v-model="filtrosAtivos"
          ></datatable-filters>
          <v-divider vertical inset class="mx-4" />
          <v-spacer />
          <v-spacer />
          <v-btn
            depressed
            color="accent"
            :to="{ name: 'tipo-documento-formulario' }"
          >
            <v-icon class="mdi mdi-file-cog-outline mr-2" />NOVO TIPO DE
            DOCUMENTO
          </v-btn>
        </v-toolbar>
      </template>
      <template v-slot:item.tipos_permitidos="{ item }">
        <v-chip
          class="mr-1"
          v-for="(tipo, i) in item.tipos_permitidos"
          small
          :key="`tipo-${i}`"
        >
          <v-icon left small>{{ iconTipo(tipo) }}</v-icon>
          {{ strTipo(tipo) }}
        </v-chip>
      </template>
      <template v-slot:item.tamanho_maximo="{ item }"
        >{{ item.tamanho_maximo }} MB</template
      >
      <template v-slot:item.tipos_proprietario="{ item }">
        <v-tooltip bottom v-if="item.tipos_proprietario.length > 0">
          <template v-slot:activator="{ on }">
            <span v-on="on"
              >{{ item.tipos_proprietario.length }} tipo{{
                item.tipos_proprietario.length > 1 ? "s" : ""
              }}</span
            >
          </template>
          <span>{{
            item.tipos_proprietario.map((r) => r.descricao).join(", ")
          }}</span>
        </v-tooltip>
        <span v-else>-</span>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-btn icon small text @click="editar(item.id)">
          <v-icon class="mdi mdi-pencil" small />
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import DatatableFilters from "../components/DatatableFilters";
export default {
  components: { DatatableFilters },
  data() {
    return {
      headers: [
        { text: "Descrição", value: "descricao" },
        {
          text: "Arquivos permitidos",
          value: "tipos_permitidos",
          align: "center",
        },
        {
          text: "Tipos de proprietário",
          value: "tipos_proprietario",
          align: "center",
        },
        { text: "Tamanho máximo", value: "tamanho_maximo", align: "center" },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      loading: true,
      tiposProprietario: [],
      filters: [
        {
          name: "descricao",
          label: "Descrição",
          type: "text",
          defaultValue: "",
        },
        {
          name: "ids_tipo_proprietario",
          label: "Tipos de proprietário",
          type: "select",
          multiple: true,
          options: [],
        },
      ],
      filtrosAtivos: JSON.parse(
        localStorage.getItem("filtros.tipos_documento") || "{}"
      ),
    };
  },
  computed: {
    tipos() {
      return this.$store.state.documento.tipos.map((t) => {
        t.tipos_proprietario = t.ids_tipo_proprietario.map((id) =>
          this.tiposProprietario.find((tp) => tp.id === id)
        );
        return t;
      });
    },
  },
  methods: {
    editar(id) {
      this.$router.push({
        name: "tipo-documento-formulario-editar",
        params: { id },
      });
    },
    strTipo(tipo) {
      switch (tipo) {
        case "imagem":
          return "Imagem";
        case "audio":
          return "Áudio";
        case "pdf":
          return "PDF";
        case "word":
          return "Word";
        case "excel":
          return "Excel";
      }
    },
    iconTipo(tipo) {
      switch (tipo) {
        case "imagem":
          return "mdi-file-image-outline";
        case "audio":
          return "mdi-volume-medium";
        case "pdf":
          return "mdi-file-pdf-outline";
        case "word":
          return "mdi-file-word-outline";
        case "excel":
          return "mdi-file-excel-outline";
      }
    },
  },
  async mounted() {
    this.$store.commit("ui/changeToolbar", {
      title: "Parâmetros: Tipos de documento",
    });

    try {
      this.tiposProprietario = await this.$store.dispatch(
        "documento/listarTiposProprietario"
      );
      this.filters.find(
        (f) => f.name === "ids_tipo_proprietario"
      ).options = this.tiposProprietario.map((g) => ({
        text: g.descricao,
        value: g.id,
      }));
      await this.$store.dispatch("documento/listarTipos");
    } catch (err) {
      console.log(err);
    } finally {
      this.loading = false;
    }
  },
};
</script>
